import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import axios from 'axios';
import { PassportAuth } from '../../contexts/AuthContext';

export function HomeNavbar({ onMobileNavOpen }) {
  const history = useHistory();
  const [information, setInformation] = useState(null);
  const { handleSignout } = useContext(PassportAuth);
  const handlePushToHome = () => {
    history.push('/');
  };
  const onSignOut = async () => {
    await handleSignout();
    history.push('/login');
  };
  useEffect(() => {
    async function fetchInfo() {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/information`,
      );
      setInformation(data);
    }
    if (!information) fetchInfo();
    return () => {};
  }, [information]);

  return (
    <>
      <nav
        className="top-0 fixed z-10 w-full flex flex-wrap items-center justify-between px-2 navbar-expand-lg shadow bg-gradient-to-r from-yellow-700 to-yellow-400"
        //     style={{ background: '#5664d2' }}
      >
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between  font-sans">
            <div className="flex">
              <div
                onClick={() => {
                  handlePushToHome();
                }}
                className="cursor-pointer text-white text-lg mt-3  leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase"
              >
                {information?.name}
              </div>
            </div>
            <div></div>

            <div className=" text-xs py-3 px-1 ">
              <div
                className="bg-white py-2 px-1 text-yellow-700 hover:text-purple-700 rounded-md  cursor-pointer"
                onClick={() => {
                  onSignOut();
                }}
              >
                ออกจากระบบ
              </div>
            </div>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => onMobileNavOpen()}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}
HomeNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};
export default HomeNavbar;
